@import 'styles/mixins';
@import 'styles/variables';

.header {
  margin-bottom: 16px;
  justify-content: space-between;
  display: flex;
}

.errors {
  color: var(--negative-50);
}

.actions {
  margin-top: 12px;
  padding: 8px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .right {
    column-gap: 8px;
    display: flex;
  }
}

.newStatusButton {
  @include for-phone-only {
    width: calc(100% - 50px);
    margin: 0 0 24px 20px;
  }
}
